var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSecurityApplianceFill(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 6,
    fill: "currentColor"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 5L7 9v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V9l-9-4zm0 10.99h7c-.53 4.12-3.28 7.79-7 8.94V16H9v-5.7l7-3.11v8.8z",
    fill: "#fff"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzIiIGhlaWdodD0iMzIiIHZpZXdCb3g9IjAgMCAzMiAzMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3Qgd2lkdGg9IjMyIiBoZWlnaHQ9IjMyIiByeD0iNiIgZmlsbD0iY3VycmVudENvbG9yIi8+CjxwYXRoIGQ9Ik0xNiA1TDcgOVYxNUM3IDIwLjU1IDEwLjg0IDI1Ljc0IDE2IDI3QzIxLjE2IDI1Ljc0IDI1IDIwLjU1IDI1IDE1VjlMMTYgNVpNMTYgMTUuOTlIMjNDMjIuNDcgMjAuMTEgMTkuNzIgMjMuNzggMTYgMjQuOTNWMTZIOVYxMC4zTDE2IDcuMTlWMTUuOTlaIiBmaWxsPSJ3aGl0ZSIvPgo8L3N2Zz4K";
export { SvgSecurityApplianceFill as ReactComponent };